var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"l-section"},[_c('div',{staticClass:"grid"},[_c('div',{staticClass:"l-section__content"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }